import React from "react";
import { Stack, Typography, Grid } from "@mui/material";

import PartCard from "./PartCard";
import { useTheme } from "@mui/material/styles";

export default function PrimarySearchAppBar({ handleDrawerToggle }) {
  const theme = useTheme();

  const trendingParts = [
    {
      partNumber: "Small Flow 25319109",
      minPrice: 62,
      maxPrice: 62,
      image1: "369-1.jpg",
    },
    {
      partNumber: "Honda 1",
      minPrice: 440,
      maxPrice: 440,
      image1: "Honda1-1.jpg",
    },
    {
      partNumber: "Hyundai CNV01",
      minPrice: 330,
      maxPrice: 330,
      image1: "938-1.jpg",
    },
    {
      partNumber: "Catera 25179546",
      minPrice: 232,
      maxPrice: 232,
      image1: "619-1.jpg",
    },
    {
      partNumber: "Hyundai BSC9",
      minPrice: 403,
      maxPrice: 403,
      image1: "072-2.jpg",
    },
    {
      partNumber: "Mercedes KT0132",
      minPrice: 168,
      maxPrice: 168,
      image1: "5595-1.jpg",
    },
  ];

  return (
    <Stack>
      <Typography
        variant="h4"
        gutterBottom
        sx={{ textAlign: "center", fontFamily: "Poppins", fontWeight: 800 }}
      >
        #TRENDING
      </Typography>
      <Stack
        sx={{
          flexGrow: 1,
          borderRadius: "10px",
          backgroundColor: "#D9D9D9",
          padding: "10px",
          color: "black",
        }}
        // direction={"row"}
      >
        <Typography
          variant="h6"
          gutterBottom
          sx={{ textAlign: "center", fontFamily: "Poppins", fontWeight: 800 }}
        >
          #Trending Catalytic Converter Units
        </Typography>
        <Grid container spacing={2}>
          {trendingParts.map((part) => (
            <Grid item xs={6}>
              <PartCard part={part} canLike={true} />
            </Grid>
          ))}
        </Grid>
      </Stack>
    </Stack>
  );
}
